<template>
    <el-dialog title="新增车辆" :append-to-body="true" :visible.sync="showTag" width="30%">
        <el-form :model="form" label-width="100px" size="mini">
            <el-form-item label="名称">
                <el-input v-model="form.ambulanceName"></el-input>
            </el-form-item>
            <el-form-item label="车牌号">
                <el-input v-model="form.licensePlateNo"></el-input>
            </el-form-item>
            <el-form-item label="类型">
                <el-select v-model="form.ambulanceType">
                    <el-option v-for="(item,index) in types" :key="index" :label="item.name"
                               :value="item.id"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button @click="showTag = false" size="mini">取 消</el-button>
            <el-button type="primary" @click="sub" size="mini">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
  import {staffService} from "../service/staff";
  import {isEmpty} from "../../../common/lib/utils";
  import {AMBULANCE_TYPE, STAFF_ADD_CAR_FIELDS} from "../config";
  import {STAFF_ADD_CAR_SUCCESS} from "../events";

  export default {
    name: "add-car-dialog",
    data() {
      let form = {}, types = [];
      STAFF_ADD_CAR_FIELDS.forEach(r => {
        form[r] = '';
      })
      for (let key in AMBULANCE_TYPE) {
        types.push(AMBULANCE_TYPE[key]);
      }
      return {
        showTag: false,
        types,
        form
      }
    },
    methods: {
      show(data) {
        this.showTag = true;
        if (!isEmpty(data)) {
          STAFF_ADD_CAR_FIELDS.forEach(r => {
            data[r] && this.$set(this.form, r, data[r]);
          });
        }
      },
      hide() {
        this.showTag = false;
      },
      async sub() {
        if (this.form.id) {
          if (await staffService.modifyCar(this.form)) {
            this.hide();
            this.$message.success({
              message: '修改成功',
              onClose: () => {
                bus.$emit(STAFF_ADD_CAR_SUCCESS.id, 0);
              }
            })
          }
          return;
        }
        if (await staffService.addCar(this.form)) {
          this.hide();
          this.$message.success({
            message: '增加成功',
            onClose: () => {
              bus.$emit(STAFF_ADD_CAR_SUCCESS.id, 0);
            }
          })
        }
      }
    },
  }
</script>

<style scoped>
</style>
